import {getAllDomains} from "@/services/reccommendation";
import {LANGUAGE} from "@/shared/constants";

const state = {
  domains: [],
  language: localStorage.getItem(LANGUAGE),

}

const mutations = {
  setDomains(state, payload) {
    state.domains = payload;
  },
}

const getters = {
  domains(){
    return state.domains;
  },
}

const actions = {
  actionSetDomains({commit}) {
    return new Promise((resolve, reject) => {
      getAllDomains().then((response) => {
        commit('setDomains', response.data)
        resolve(response.data);
      }, (error) => {
        reject(error);
      });
    })
  },
}

export default {
  state,
  mutations,
  getters,
  actions,
  namespaced: true
}
